module.exports = __webpack_public_path__ + "static/media/ICONS_COLORES Y SABORES.aa4a3316.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_COLORES Y SABORES.svg
// module id = 480
// module chunks = 0